import React, { useContext } from "react";
import { useState } from "react";
import PostcodeForm from "./components/PostcodeForm";
import EmailForm from "./components/EmailForm";
import { AppContext } from "./AppContext";
import { ACTIONS } from "./reducer";

interface AppProps {}

const App: React.FunctionComponent<AppProps> = () => {
  const { dispatch } = useContext(AppContext);

  const [formStep, setFormStep] = useState(0);
  const [postcode, setPostcode] = useState("");
  const [emailSent, setEmailSent] = useState(false);

  if (dispatch === undefined) return <p>Error</p>;

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch({
      type: ACTIONS.DATA_REQUESTED,
      payload: postcode,
    });

    setFormStep(1);
  };

  return (
    <div className="flex bg-neutral-200 min-h-screen font-questrial">
      <div className="w-full bg-neutral-50">
        {!emailSent && (
          <PostcodeForm
            postcode={postcode}
            setPostcode={setPostcode}
            handleSubmit={handleSubmit}
          />
        )}
        <EmailForm setFormStep={setFormStep} onEmailSent={() => setEmailSent(true)} />
      </div>
    </div>
  );
};

export default App;
